import { useResizeListener } from '@direct-frontend/stdlib';
import { useRef, useState, useCallback, RefCallback } from 'react';

export function useScrollbarWidth() {
    const ref = useRef<HTMLElement | null>();
    const [scrollbarWidth, setScrollbarWidth] = useState<number | null>(null);
    const calcScrollbarWidth = useCallback(() => {
        if (!ref.current) {
            setScrollbarWidth(null);
            return;
        }

        setScrollbarWidth(ref.current.offsetWidth - ref.current.clientWidth);
    }, [ref]);

    const setResizeListenerRef = useResizeListener(calcScrollbarWidth);

    const setRef = useCallback<RefCallback<HTMLElement>>(
        node => {
            ref.current = node;
            setResizeListenerRef(ref.current);
            calcScrollbarWidth();
        },
        [setResizeListenerRef, calcScrollbarWidth],
    );

    return { scrollbarWidth, setRef };
}
